import { useState } from 'react';
import { OnDesktop, Text, Toggle } from '@hopskipdrive/react-components';

import { useAuthQuery } from '../../../auth/hooks/useAuthQuery';
import { PageHeading } from '../../../shared/components/PageHeading';
import { useNavigation } from '../../../shared/hooks/useNavigation';
import { trackFullStoryEvent } from '../../../vendor/features/FullStory/FullStory.service';

import { StyledToggle } from './styles';

export const RidesListToggle = ({ title, currentToggleValue }) => {
  const { navigateTo } = useNavigation();
  const { isOnsiteStaffUser } = useAuthQuery();
  const [toggleValue, setToggleValue] = useState(currentToggleValue);

  return isOnsiteStaffUser ? null : (
    <>
      <OnDesktop>
        <PageHeading fontWeight={700} data-testid="page-title" variant="h1">
          {title}
        </PageHeading>
        <Text variant="h2"></Text>
      </OnDesktop>
      <StyledToggle>
        <Toggle
          onChange={(_, newValue) => {
            if (!newValue) {
              return;
            }
            setToggleValue(newValue);
            trackFullStoryEvent('ride_calendar_viewed', { view_type: newValue });
            navigateTo(newValue === 'all_rides' ? '/rides' : '/rides/daily_queue');
          }}
          value={toggleValue}
          exclusive
        >
          <Toggle.Option value={'all_rides'}>{'All Rides'}</Toggle.Option>
          <Toggle.Option value={'daily_queue'}>{'Daily Queue'}</Toggle.Option>
        </Toggle>
      </StyledToggle>
    </>
  );
};
